import React from 'react';

const NotUnlockedApplicationIcon = () => {
    return (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2 2L22 22" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M5 5C4.73478 5 4.48043 5.10536 4.29289 5.29289C4.10536 5.48043 4 5.73478 4 6V13C4 18 7.5 20.5 11.67 21.94C11.8855 22.0203 12.1222 22.0238 12.34 21.95C14.69 21.13 16.82 19.98 18.24 18.24" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M9.30859 3.65245C9.99506 3.25856 10.6418 2.79908 11.2396 2.28045C11.4514 2.09945 11.7209 2 11.9996 2C12.2782 2 12.5477 2.09945 12.7596 2.28045C14.5096 3.81045 16.9996 5.00045 18.9996 5.00045C19.2648 5.00045 19.5192 5.10581 19.7067 5.29334C19.8942 5.48088 19.9996 5.73523 19.9996 6.00045V13.0004C20.0003 13.4231 19.9735 13.8453 19.9196 14.2644" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};

export default NotUnlockedApplicationIcon;


